import { LuSend } from "react-icons/lu";
import ChatMessage from "../../Component/chat/ChatMessage";
import React, { useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import { Link, useParams } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import toast from "react-hot-toast";
import { useRef } from "react";
import AdminTicketModal from "./AdminTicketModal";

export default function ContactAdminChat() {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [chatData, setChatData] = useState([]);
  const [loadingAnswer, setLoadingAnswer] = useState(false);
  const [chatAnswer, setChatAnswer] = useState("");
  const [isClosed, setIsClosed] = useState(false);
  const [closeModalOpen, setCloseModalOpen] = useState(false);
  const textareaRef = useRef(null);
  const messagesEndRef = useRef(null);

  const getAdminChats = async () => {
    setLoading(true);
    try {
      const res = await apiRequests.get(
        `/tickets/v1/get-ticket-messages-seller/${id}`,
      );
      setChatData(res.data.data || []);
      setTimeout(() => {
        scrollToBottom();
      }, 100);
      console.log("chatdata", chatData);
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAdminChats();
  }, []);

  const answerTicket = async () => {
    if (!chatAnswer.trim()) return;

    setLoadingAnswer(true);

    const payload = {
      ticket_id: id,
      description: chatAnswer.trim(),
    };

    try {
      const res = await apiRequests.put(
        `/tickets/v1/seller-answer-ticket`,
        payload,
      );

      toast.success(res.data.en_message);
      setChatAnswer("");
      if (textareaRef.current) {
        textareaRef.current.style.height = "auto";
      }
      await getAdminChats();
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setLoadingAnswer(false);
    }
  };

  const closeTicket = async () => {
    try {
      const payload = {
        ticket_id: id,
      };

      const res = await apiRequests.put(
        `/tickets/v1/seller-close-ticket`,
        payload,
      );

      const result = res.data.data;

      if (!result.success) {
        toast.error(result.en_message || "The ticket cannot be closed.");
        return;
      }

      toast.success(result.en_message || "Ticket closed successfully");

      setIsClosed(true);
      setCloseModalOpen(false);

      await getAdminChats();
    } catch (err) {
      console.log(err);

      toast.error(
        err.response?.data?.data?.en_message || "Failed to close ticket",
      );
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="flex flex-col h-[calc(100vh-80px)] w-full overflow-hidden bg-white relative">
        {" "}
        <div className="grid grid-cols-3 sm:grid-cols-1 sm:gap-3 sm:px-3 sm:py-3 sm:border-b sm:border-gray-100">
          <div className="col-span-1 flex sm:order-1 sm:justify-between sm:items-center">
            <Link
              to={"/contactadmin"}
              className="ml-10 md:ml-2 sm:ml-0 bg-[#051F33] rounded-xl text-white w-32 md:w-20 sm:w-9 sm:h-9 flex justify-center items-center p-2 sm:p-0"
            >
              <FaChevronLeft />
              <p className=" md:hidden sm:hidden">back to chats</p>
              <p className="hidden md:block sm:hidden">back</p>
            </Link>

            {!isClosed ? (
              <button
                onClick={() => setCloseModalOpen(true)}
                className="hidden sm:flex items-center gap-1.5 bg-red-50 text-red-600 px-4 py-2 rounded-xl hover:bg-red-100 transition text-sm font-medium"
              >
                Close ticket
              </button>
            ) : (
              <span className="hidden sm:block bg-gray-100 text-gray-500 px-4 py-2 rounded-xl text-sm font-medium">
                Closed
              </span>
            )}
          </div>
          <div className="col-span-1 flex items-center justify-center gap-1 sm:order-2 sm:justify-start sm:flex-wrap">
            <span className="text-firstColor-shade1">Subject:</span>
            {loading ? (
              <div className="w-36 h-7 bg-gradient-to-l from-gray-300 to-gray-400 animate-pulse rounded-lg " />
            ) : (
              <>
                <span className="text-xl">
                  {chatData[0]?.ticket_id?.subject}
                </span>
              </>
            )}
          </div>
          <div className="col-span-1 flex justify-end items-center mr-10 sm:hidden">
            {!isClosed ? (
              <button
                onClick={() => setCloseModalOpen(true)}
                className="bg-red-500 text-white px-5 py-2.5 rounded-xl hover:bg-red-600 transition"
              >
                Close ticket
              </button>
            ) : (
              <span className="bg-gray-200 text-gray-600 px-5 py-2.5 rounded-xl">
                Closed
              </span>
            )}
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-10 sm:p-4 flex flex-col gap-4 min-h-0">
          {loading ? (
            <>
              <div className="w-full flex justify-end">
                <div className="w-80 sm:w-full h-28 rounded-2xl rounded-tr-none bg-gradient-to-l from-gray-300 to-gray-400 animate-pulse "></div>
              </div>
              <div className="w-full flex justify-start">
                <div className="w-80 sm:w-full h-28 rounded-2xl rounded-tl-none bg-gradient-to-r from-gray-300 to-gray-400 animate-pulse "></div>
              </div>
            </>
          ) : (
            <>
              {chatData.map((item, _id) => (
                <div key={_id}>
                  <div
                    className={`relative flex flex-col w-fit max-w-80 sm:max-w-[85%] min-w-32 h-fit mt-4 justify-between rounded-2xl p-5 sm:p-4
                                        ${item.sender.admin_id ? "mr-auto rounded-tl-none bg-[#F0E1D9]" : " ml-auto rounded-tr-none bg-[#ADD3F2]"} 
                                        `}
                  >
                    <div className="mb-4">
                      <p className="text-gray-800 whitespace-pre-wrap break-words">
                        {item.description}
                      </p>
                    </div>
                    <span
                      className={`text-xs text-gray-500 absolute bottom-2 ${item.sender.admin_id ? "right-4" : "left-4"}`}
                    >
                      {new Date(item.updatedAt).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </>
          )}
        </div>
        {!isClosed ? (
          <div className="sticky bottom-0 bg-[#F0E1D9] rounded-2xl mx-4 sm:mx-2 p-3">
            <div className="p-1 flex flex-row justify-center items-center w-full border border-[#937B6C] h-full rounded-2xl bg-[#F0E1D9]">
              <textarea
                placeholder="Type a message"
                className="w-full p-4 sm:p-3 rounded-lg outline-none resize-none overflow-hidden bg-[#F0E1D9]"
                rows={1}
                style={{ maxHeight: "72px" }}
                ref={textareaRef}
                value={chatAnswer}
                onChange={(e) => {
                  setChatAnswer(e.target.value);

                  const textarea = e.target;

                  textarea.style.height = "auto";

                  const maxHeight = 72; // 3 lines

                  if (textarea.scrollHeight > maxHeight) {
                    textarea.style.height = `${maxHeight}px`;
                    textarea.style.overflowY = "auto";
                  } else {
                    textarea.style.height = `${textarea.scrollHeight}px`;
                    textarea.style.overflowY = "hidden";
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();

                    if (!loadingAnswer && chatAnswer.trim()) {
                      answerTicket();
                    }
                  }
                }}
              />
              <figure
                className="pr-4 sm:pr-2 cursor-pointer hover:text-gray-700"
                onClick={answerTicket}
              >
                <LuSend className="text-2xl text-[#937B6C]" />
              </figure>
            </div>
          </div>
        ) : (
          <div className="m-4 sm:m-2 p-4 rounded-2xl bg-gray-100 text-center text-gray-500">
            This ticket is closed
          </div>
        )}
      </div>

      <AdminTicketModal
        isOpen={closeModalOpen}
        onClose={() => setCloseModalOpen(false)}
      >
        <div className="flex flex-col gap-5">
          <p className="font-bold text-xl">Close Ticket</p>

          <p className="text-gray-600">
            Are you sure you want to close this ticket?
          </p>

          <div className="flex justify-end gap-3">
            <button
              onClick={() => setCloseModalOpen(false)}
              className="px-5 py-2.5 rounded-xl bg-gray-200"
            >
              Cancel
            </button>

            <button
              onClick={closeTicket}
              className="px-5 py-2.5 rounded-xl bg-red-500 text-white"
            >
              Close Ticket
            </button>
          </div>
        </div>
      </AdminTicketModal>
    </>
  );
}
